import {
  determineMarketplaceTourKind,
  type MarketplaceTourKind,
} from '@opendoor/shared-ts/marketplace-tour';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

import { isBuyDirectEligible } from './buyDirectHelpers';

export type TourKind = MarketplaceTourKind;

export const TOUR_ACTION_TEXT_NON_BUY_DIRECT = {
  selfTour: 'Self-tour',
  tourWithAgent: 'Share home',
} satisfies Record<TourKind, string>;

export const TOUR_ACTION_TEXT_BUY_DIRECT = {
  selfTour: 'Self-tour',
  tourWithAgent: 'Tour with agent',
} satisfies Record<TourKind, string>;

export type PropertyActionabilityInput = Pick<
  MarketplaceProperty,
  | 'buyDirectPrice'
  | 'canSelfTour'
  | 'displayBadge'
  | 'hasCurrentAvailability'
  | 'listingState'
  | 'buyDirectStatus'
>;

export const determinePropertyActionability = (property: PropertyActionabilityInput) => {
  if (!property.hasCurrentAvailability) {
    return {
      isActionable: false,
      tourKind: null,
      showBuyDirect: false,
      disableBuyDirect: true,
    };
  }

  const tourKind = determineMarketplaceTourKind(property);
  const isActionable = tourKind !== null;

  const showBuyDirect = isBuyDirectEligible(property) && (property.buyDirectPrice ?? 0) > 0;

  const disableBuyDirect =
    property.displayBadge === 'IN_CONTRACT' ||
    property.listingState === 'IN_CONTRACT' ||
    (property.buyDirectStatus !== null && property.buyDirectStatus !== 'AVAILABLE');

  return {
    isActionable,
    tourKind,
    showBuyDirect,
    disableBuyDirect,
  };
};
